import Controller from '@ember/controller';
import { type Registry as Services, service } from '@ember/service';
import type HotelDayByDaySpiderDashboardRoute from 'lumen/routes/hotel/day-by-day/spider-dashboard';
import type { ModelFrom } from 'lumen/utils/routes';

export default class HotelDayByDaySpiderDashboardController extends Controller {
  declare model: ModelFrom<HotelDayByDaySpiderDashboardRoute>;

  queryParams = [
    'asof',
    'data_replatforming',
    'debug',
    'endDate',
    'pickupFrom',
    'startDate',
    'tooltipHierarchy',
  ];

  @service declare currency: Services['currency'];
  @service declare currencyConversion: Services['currency-conversion'];
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];

  declare dashboard: string;

  get iframeQPs(): Record<string, unknown> {
    const iframeQPs: Record<string, unknown> = {
      iframe: 1,
      origin: window.location.origin,
    };

    if (this.currency.selectedCurrency) {
      iframeQPs['currency'] = this.currency.selectedCurrency;
    }

    if (this.currencyConversion.selectedProfileId) {
      iframeQPs['currencyVariant'] = this.currencyConversion.selectedProfileId;
    }

    if (this.hotelAndMarketService.hotel) {
      iframeQPs['subscriptionId'] = this.hotelAndMarketService.hotel.id;
    }

    this.queryParams.forEach((queryParam) => {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const value = this[queryParam]!;

      if (value) {
        iframeQPs[queryParam] = value;
      }
    });

    return iframeQPs;
  }

  get urlForEmbeddedApp(): string {
    const { dashboard, model } = this;

    // @ts-expect-error: Incorrect type
    return `/dashboards/day-by-day/${model.spiderId}/${dashboard}`;
  }

  constructor() {
    // eslint-disable-next-line prefer-rest-params
    super(...arguments);

    this.queryParams.forEach((queryParam) => {
      // @ts-expect-error: Incorrect type
      this[queryParam] = null;
    });
  }
}
